<template>
  <div v-if="ticket">
    <!-- detalji provjere: šta je server provjerio (polje info) -->
    <div v-if="mode === 'details'" class="c4-chk">
      <div v-for="(row, i) in checks" :key="i" class="c4-chk-i">
        <i :class="{ no: !row.ok }"><span class="mdi" :class="row.ok ? 'mdi-check-bold' : 'mdi-close'" aria-hidden="true"></span></i>
        <div>
          <b>{{ row.message }}</b>
          <code v-if="row.params">{{ row.params }}</code>
        </div>
      </div>
      <div v-if="!checks.length" class="c4-pr">{{ tx("det.none") }}</div>
    </div>

    <!-- sve stavke jedne kartice -->
    <div v-else-if="mode === 'items'" class="c4-il">
      <div v-for="(it, i) in ticket.outcome.items" :key="i" class="r">
        <span class="c4-ph" :class="{ none: !it.image }">
          <img v-if="it.image" :src="imageUrl(it)" alt="" loading="lazy" />
          <i v-else class="mdi mdi-image-off-outline" aria-hidden="true"></i>
        </span>
        <div class="c4-iname">{{ toLatin(it.name) }}<span v-if="adds(it)" class="c4-adds">: {{ adds(it) }}</span></div>
        <span v-if="it.quantity > 1" class="c4-qty">×{{ it.quantity }}</span>
        <span v-else></span>
      </div>
    </div>

    <!-- kartica iz trake "Izdato" -->
    <div v-else>
      <div class="c4-pb" :data-tone="K.tone">
        <i class="mdi" :class="K.icon" aria-hidden="true"></i><b>{{ tx("o." + ticket.kind) }}</b>
      </div>
      <div class="c4-pw">
        <template v-if="ticket.outcome.user">
          <b>{{ fullName }}</b>
          <span>{{ [ticket.outcome.user.company, ticket.outcome.shift ? ticket.outcome.shift + ". " + tx("shift") : ""].filter(Boolean).join(" · ") }}</span>
        </template>
        <b v-else>ID {{ ticket.code }}</b>
      </div>
      <div v-if="K.can && ticket.conf !== 'done'" class="c4-pw-w" role="alert">
        <i class="mdi mdi-alert-circle-outline" aria-hidden="true"></i><span>{{ tx("past.unconf") }}</span>
      </div>
      <div v-if="ticket.outcome.items.length && ticket.kind !== 'stop'" class="c4-il">
        <div v-for="(it, i) in ticket.outcome.items" :key="i" class="r">
          <span class="c4-ph" :class="{ none: !it.image }">
            <img v-if="it.image" :src="imageUrl(it)" alt="" loading="lazy" />
            <i v-else class="mdi mdi-image-off-outline" aria-hidden="true"></i>
          </span>
          <div class="c4-iname">{{ toLatin(it.name) }}<span v-if="adds(it)" class="c4-adds">: {{ adds(it) }}</span></div>
          <span v-if="it.quantity > 1" class="c4-qty">×{{ it.quantity }}</span>
          <span v-else></span>
        </div>
      </div>
      <div v-else class="c4-pr">{{ reason }}</div>
    </div>
  </div>
</template>

<script>
import conf from "@/config";
import canteenV4Text from "@/mixins/canteenV4Text";
import { KINDS } from "@/utils/canteenOutcome";

export default {
  name: "CanteenTicketSheet",
  mixins: [canteenV4Text],
  props: {
    // details | items | past
    mode: { type: String, default: "details" },
    ticket: { type: Object, default: null },
    restaurantId: { type: [Number, String], default: "" },
  },
  computed: {
    K() {
      return KINDS[this.ticket.kind];
    },
    fullName() {
      const u = this.ticket.outcome.user;
      return u ? `${this.toLatin(u.name)} ${this.toLatin(u.lastname)}`.trim() : "";
    },
    // info[] sa servera: { message, status: "da" | "ne", params }
    checks() {
      const info = this.ticket.outcome.info;
      const list = Array.isArray(info) ? info : Object.values(info || {});
      return list.map((row) => ({
        message: this.translate(String((row && row.message) || "")),
        ok: row && String(row.status).toLowerCase() === "da",
        params: row && row.params ? (typeof row.params === "string" ? row.params : JSON.stringify(row.params)) : "",
      }));
    },
    reason() {
      switch (this.ticket.kind) {
        case "taken":
          return `${this.tx("foot.noserve")}. ${this.tx("taken.note")}`;
        case "stop":
          return `${this.tx("foot.noserve")}. ${this.tx("why.stop_next")}`;
        case "unknown":
          return this.tx("why.unknown_sub");
        case "error":
          return this.tx("why.error_sub");
        default:
          return this.tx("why.session_sub");
      }
    },
  },
  methods: {
    imageUrl(it) {
      return `${conf.apiUrlBase}/gallery/${this.restaurantId}/medium/${it.image}`;
    },
  },
};
</script>
